import { render, staticRenderFns } from "./Prealerta.vue?vue&type=template&id=196f6be2&scoped=true"
import script from "./Prealerta.vue?vue&type=script&lang=js"
export * from "./Prealerta.vue?vue&type=script&lang=js"
import style0 from "./Prealerta.vue?vue&type=style&index=0&id=196f6be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f6be2",
  null
  
)

export default component.exports